{
  "title": "Tagged Photo Report",
  "description": "Print a coverage report for this season's campers: who has a training photo, how many published tags they have, and how long since they were last tagged.",
  "filters": {
    "heading": "Filters",
    "loading": "Loading filter options…",
    "sessionsLabel": "Sessions",
    "divisionsLabel": "Divisions",
    "bunkPlanLabel": "Bunk plan",
    "bunkPlanNone": "No bunk plan",
    "bunkPlanHelp": "Optional. Selecting a bunk plan adds a bunk column to the printed report.",
    "selectAll": "Select all",
    "clearSelection": "Clear",
    "allSessionsHint": "All sessions will be included.",
    "allDivisionsHint": "All divisions will be included.",
    "sessionsEmpty": "This season has no sessions.",
    "divisionsEmpty": "This season has no divisions.",
    "submit": "Print report"
  },
  "states": {
    "idle": "Choose your filters, then print the report.",
    "loading": "Building the report…",
    "empty": "No campers matched these filters.",
    "ready": "The report has been sent to your browser's print dialog. Choose a printer, or save it as a PDF."
  },
  "report": {
    "seasonLabel": "Season",
    "columns": {
      "lastName": "Last Name",
      "firstName": "First Name",
      "personId": "Person ID",
      "sessions": "Sessions",
      "divisions": "Divisions",
      "trained": "Training Photo",
      "taggedPhotoCount": "Tags This Season",
      "daysSinceLastTag": "Days Since Last Tag",
      "daysSource": "Based On"
    },
    "daysSource": {
      "tag": "Tag time",
      "photo": "Photo date"
    }
  },
  "export": {
    "label": "Export CSV",
    "help": "Saves the report you are looking at as a spreadsheet file."
  }
}
